import React, {HtmlHTMLAttributes} from 'react'
import {Link} from 'react-router-dom'

interface HeaderCardProps extends HtmlHTMLAttributes<HTMLDivElement> {
  buttonBack: any
  routeBack: any
  subtitle?: any
}

const HeaderCard: React.FC<HeaderCardProps> = (props) => {
  return (
    <div
      className='card-header border-0 cursor-pointer'
      role='button'
      data-bs-target='#kt_account_profile_details'
      aria-expanded='true'
      aria-controls='kt_account_profile_details'
    >
      <div className='card-title'>
        <h3 className='fw-bolder m-0'>
          {props.title}
          <div className='text-gray-400 fw-bold mt-3 fs-6'>{props.subtitle}</div>
        </h3>
      </div>

      <div className='card-toolbar d-flex justify-content-end  py-6'>
        <Link to={props.routeBack}>
          <button
            type='button'
            className='btn btn-sm btn-outline btn-outline-dark border-1 border-gray-300 '
          >
            {props.buttonBack}
          </button>
        </Link>
      </div>
    </div>
  )
}

export default HeaderCard
